import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface FlowState {
  activeFile: string
}

const initialState: FlowState = {
  activeFile: ''
}

const fileExplorerSlice = createSlice({
  name: 'fileExplorer',
  initialState,
  reducers: {
    setActiveFile(state, action: PayloadAction<string>) {
      state.activeFile = action.payload
    }
  }
})

export const { setActiveFile } = fileExplorerSlice.actions
export default fileExplorerSlice.reducer
